import MyMessageList from './src/main';

/* istanbul ignore next */
MyMessageList.install = function(Vue) {
  Vue.component(MyMessageList.name, MyMessageList);
};
export default MyMessageList;



// WEBPACK FOOTER //
// ./src/components/my-messageList/index.js